import { Button, dialog } from "nq-component";
import React, { Component } from "react";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import BasePage from "../../../../base/BasePage";
import { upsertUseCase, findObjectUseCase } from "../../../../usecases/object";

export default class AssignBankDetail extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      objectID: "",
      id: props.bankData.id || "",
      bank: props.bankData.bank || "",
      branch: props.bankData.branch || "",
      accountName: props.bankData.accountName || "",
      accountNumber: props.bankData.accountNumber || "",
    };
  }

  async componentDidMount() {
    const { id } = this.state;
    const employees = await findObjectUseCase().execute("employees", {
      where: { id: id },
    });
    if (employees.length > 0) {
      const employee = employees[0];
      const { Firstname, Middlename, surname } = employee;
      const fullName = `${Firstname || ""} ${Middlename || ""} ${
        surname || ""
      }`.trim();

      this.setState({
        fullName,
      });
    } else {
      console.warn("No employee found with the given ID.");
    }
  }

  dialogClose() {
    dialog.close();
  }

  onChangeBank(bank) {
    this.setState({ bank });
  }

  onChangeBranch(branch) {
    this.setState({ branch });
  }

  onChangeAccNo(accountNumber) {
    this.setState({ accountNumber });
  }

  onChangeAccName(accountName) {
    this.setState({ accountName });
  }

  async confirmChanges() {
    try {
      const { bank, branch, accountNumber, accountName, id } = this.state;
      // Fetch the existing employees
      const employees = await findObjectUseCase().execute("employees");
      const employee = employees.find((emp) => emp.id === id);

      if (employee) {
        const updateData = {
          ...employee,
          bank: bank,
          branch: branch,
          accountNumber: accountNumber,
          accountName: accountName,
        };

        delete updateData.selectedSchedule;

        await upsertUseCase().execute("employees", updateData);
      } else {
        console.log("not found");
      }
      this.dialogClose();
      this.showSuccess("Success! Bank Detail Saved");
      this.props.closeModal();
      this.props.refetchData();
    } catch (error) {
      console.error(
        "An error occurred while handling enroll button click:",
        error
      );
    }
  }

  handleClickOk() {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row" style={{ textAlign: "center" }}>
            <p>
              <i
                className="bi bi-question-circle"
                style={{ color: "orange", fontSize: "20px" }}
              ></i>{" "}
              You are about to assign bank details to
              <div>
                <b>{this.state.fullName}</b>
              </div>
            </p>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, .65)",
              }}
            >
              Please click on OK to confirm changes.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  render() {
    const isMobile = window.innerWidth <= 768;
    return (
      <>
        <>
          <div
            className="w-100 h-100 position-fixed end-0 start-0 overflow-y-auto d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1050,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            }}
          >
            {/* Existing modal content */}
            <div
              className="w-100 d-flex column align-items-center"
              style={{
                maxHeight: "99%",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: isMobile ? "90%" : "35rem",
                }}
              >
                <CardView style={{ padding: 0 }}>
                  <h4 className="fs-6 fw-bold pt-3 ps-3">
                    Assign Bank Account
                  </h4>
                  <hr />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      this.handleClickOk();
                    }}
                  >
                    <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                      <label
                        style={{ fontSize: "12px", paddingBottom: "10px" }}
                      >
                        Bank:
                      </label>
                      <InputFactory
                        onChange={this.onChangeBank.bind(this)}
                        type="String"
                        field="bank"
                        value={this.state.bank}
                      />
                    </div>
                    <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                      <label
                        style={{ fontSize: "12px", paddingBottom: "10px" }}
                      >
                        Branch:
                      </label>
                      <InputFactory
                        onChange={this.onChangeBranch.bind(this)}
                        type="String"
                        field="branch"
                        value={this.state.branch}
                      />
                    </div>
                    <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                      <label
                        style={{ fontSize: "12px", paddingBottom: "10px" }}
                      >
                        Account Number:
                      </label>
                      <InputFactory
                        onChange={this.onChangeAccNo.bind(this)}
                        type="String"
                        field="accountNumber"
                        value={this.state.accountNumber}
                      />
                    </div>
                    <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                      <label
                        style={{ fontSize: "12px", paddingBottom: "10px" }}
                      >
                        Account Name:
                      </label>
                      <InputFactory
                        onChange={this.onChangeAccName.bind(this)}
                        type="String"
                        field="accountName"
                        value={this.state.accountName}
                      />
                    </div>
                    <br></br>
                    <hr />
                    <div className="w-100 d-flex justify-content-end gap-3 mb-3 pe-3">
                      <Button
                        className="btn btn-light fs-sm"
                        onClick={() => this.props.closeModal()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn btn-primary"
                        type="submit"
                        // onClick={this.handleClickOk.bind(this)}
                      >
                        OK
                      </Button>
                    </div>
                  </form>
                </CardView>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
